// extracted by mini-css-extract-plugin
export default {"content":"HomeLayout_content__OBtai"};